import React from "react";
import { CheckCircle2 } from "lucide-react";
import { BRAND } from "@/lib/brand";

const items = [
  "Official WhatsApp Business API",
  `${BRAND.trust.clients} Clients`,
  `${BRAND.trust.messages} Messages Delivered`,
  `${BRAND.trust.activeBusinesses} Active Businesses`,
  `${BRAND.trust.experience} Experience`,
  `Dedicated Support (${BRAND.support.hours})`,
];

export const TrustStrip = () => {
  return (
    <section className="bg-white" data-testid="trust-strip">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-10 sm:pt-14">
        <div className="rounded-3xl bg-gradient-to-r from-emerald-50 via-white to-blue-50 border border-slate-200 px-5 sm:px-7 py-5">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {items.map((t) => (
              <div
                key={t}
                data-testid={`trust-strip-item-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                className="flex items-start gap-2 text-sm font-semibold text-slate-800"
              >
                <CheckCircle2 className="h-4 w-4 text-emerald-600 flex-shrink-0 mt-0.5" />
                <span>{t}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
